export default {
	roles: [
		{ id: 0, text: "אדמין", rule: "admin" },
		{ id: 1, text: "מנהל הגרלה", rule: "manager" },
	],
	rules: {
		admin: { route: "admin", baseUrl: "/api/admin" },
		manager: { route: "manager", baseUrl: "/api/admin" },
	},
};
